/* eslint-disable react/jsx-props-no-spreading */
// eslint-disable-next-line no-use-before-define
import React, { FC } from 'react';

export enum ButtonVariants {
  PRIMARY = 'primary', // eslint-disable-line no-unused-vars
  SECONDARY = 'secondary', // eslint-disable-line no-unused-vars
  SUCCESS = 'success', // eslint-disable-line no-unused-vars
  DANGER = 'danger', // eslint-disable-line no-unused-vars
  WARNING = 'warning', // eslint-disable-line no-unused-vars
  INFO = 'info', // eslint-disable-line no-unused-vars
  LIGHT = 'light', // eslint-disable-line no-unused-vars
  DARK = 'dark', // eslint-disable-line no-unused-vars
  GRAY = 'gray', // eslint-disable-line no-unused-vars
  LINK = 'link', // eslint-disable-line no-unused-vars
}

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariants | string;
  children?: React.ReactNode;
  icon?: string;
  text?: string;
  outlineStyle?: boolean;
  dimStyle?: boolean;
  disabled?: boolean;
  className?: string;
  lgSize?: boolean;
}

const Button: FC<ButtonProps> = ({
  variant = ButtonVariants.PRIMARY,
  children,
  icon,
  text,
  outlineStyle,
  dimStyle,
  disabled,
  className,
  lgSize = false,
  ...props
}) => {
  const iconClassName = icon && !text && !children ? 'btn-icon' : '';
  const dimClassName = dimStyle ? 'btn-dim' : '';
  const variantClassName = outlineStyle
    ? `btn-outline-${variant}`
    : `btn-${variant}`;
  const sizeClassName = lgSize ? 'btn-lg' : '';

  const buttonClassName = [
    'btn',
    iconClassName,
    dimClassName,
    variantClassName,
    sizeClassName,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type="button"
      className={`${buttonClassName} ${className}`}
      disabled={disabled}
      {...props}
    >
      {icon && (
        <em className={`icon ni ni-${icon} ${children ? 'mr-1' : ''}`} />
      )}

      {text ? <span>{text}</span> : null}

      {children}
    </button>
  );
};

export default Button;
